import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import Input from '@lib/components/Input/Input';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import {
  isWidgetSelected,
  getConditionalUrlValidation,
  getConditionalStringValidation,
} from './validationHelpers';

/**
 * Returns fields for External Link widget
 */
export default function getExternalLinkFields(t: TFunction): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.ExternalLinkInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-external-link-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.ExternalLink),
    },
    {
      name: WidgetFieldNames.ExternalUrl,
      label: t('link'),
      element: Input,
      validation: getConditionalUrlValidation(t, WidgetsKindEnum.ExternalLink),
      isOptionalFn: () => false,
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.ExternalLink),
    },
    {
      name: WidgetFieldNames.ExternalLinkTitle,
      label: t('home.widget-title'),
      element: Input,
      validation: getConditionalStringValidation(
        t,
        WidgetsKindEnum.ExternalLink,
      ),
      isOptionalFn: () => false,
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.ExternalLink),
    },
  ];
}
